<template>
  <div class="content__wrapper">
    <folder-header
      v-if="model.children.length"
      :folder="model"
    />
    <div class="content">
      <div
        v-for="item of model.children"
        :key="item.label"
      >
        <module-card :module="item" />
      </div>
    </div>
  </div>
</template>
<script>
import ModuleCard from '@/modules/DataManagement/views/module/components/ModuleCard.vue';
import FolderHeader from '@/modules/DataManagement/views/module/components/FolderHeader.vue';

export default {
  name: 'SimpleCardsGrid',
  components: {
    FolderHeader,
    ModuleCard,
  },
  props: ['model'],

};
</script>

<style scoped lang="scss">
.content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
}
</style>